import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { IMAGE_BASE_URL } from '../constants/paths';
import LeadershipSection from './LeadershipSection';

const Section = styled.section`
  padding: 80px 0;
  background-color: #f9f9f9;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 10px;
  color: #222;
`;

const Subtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 40px;
`;

const Image = styled.img`
  width: 100%;
  border-radius: 12px;
  object-fit: cover;
  max-height: 400px;
`;

const Content = styled.div`
  font-size: 1.1rem;
  color: #333;
  line-height: 1.7;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 40px;
`;

const InfoCard = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;

  h4 {
    color: #117964;
    margin-bottom: 10px;
  }

  p {
    font-size: 1rem;
    color: #555;
  }
`;

const AboutUsSection = () => {
  const church = JSON.parse(localStorage.getItem('church')) || {};
  const aboutImage = church.about_image
    ? IMAGE_BASE_URL + church.about_image
    : 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?auto=format&fit=crop&w=870&q=80';

  const aboutText = church.about_text || `We are a Christ-centered, Spirit-filled church committed to transforming lives and communities through the love of Jesus. Our mission is to disciple believers, reach the lost, and serve our neighbors with compassion and excellence.`;

  return (
    <Section id="about">
      <Container>
        <Title>About Us</Title>
        <Subtitle>Learn more about our mission, vision and values</Subtitle>
        <Row>
          <Col md={6}>
            <Image src={aboutImage} alt="About our church" />
          </Col>
          <Col md={6}>
            <Content>
              <p>{aboutText}</p>
            </Content>
          </Col>
        </Row>

        <CardGrid>
          <InfoCard>
            <h4>Our Mission</h4>
            <p>{church.mission}</p>
          </InfoCard>

          <InfoCard>
            <h4>Our Vision</h4>
            <p>{church.vision}</p>
          </InfoCard>

          {/*<InfoCard>
            <h4>Our Core Values</h4>
            <p>Faith, Love, Discipleship, Compassion, Community, and Integrity.</p>
          </InfoCard>*/}
        </CardGrid>
      </Container>
      <LeadershipSection/>
    </Section>
  );
};

export default AboutUsSection;
